import axiosInstance from "./axios-instance";

/**
 * קבלת רשימת משתמשים
 */
export const getUsers = async (schoolId?: string): Promise<any> => {
  try {
    const url = schoolId 
      ? `/admin/users?schoolId=${schoolId}`
      : "/admin/users";
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error: any) {
    console.error(
      "Error fetching users:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

/**
 * קבלת משתמש לפי מזהה
 */
export const getUserById = async (userId: string): Promise<any> => {
  try {
    const response = await axiosInstance.get(`/admin/users/${userId}`);
    return response.data;
  } catch (error: any) {
    console.error(
      "Error fetching user:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

/**
 * עדכון משתמש קיים
 */
export const updateUser = async (
  userId: string,
  userData: any
): Promise<any> => {
  try {
    const response = await axiosInstance.put(
      `/admin/users/${userId}`,
      userData
    );
    return response.data;
  } catch (error: any) {
    console.error(
      "Error updating user:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

/**
 * יצירת משתמש חדש
 */
export const createUser = async (userData: any): Promise<any> => {
  try {
    const response = await axiosInstance.post("/admin/users", userData);
    return response.data;
  } catch (error: any) {
    console.error(
      "Error creating user:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

/**
 * מחיקת משתמש
 */
export const deleteUser = async (
  userId: string,
  forceDelete = false
): Promise<any> => {
  try {
    const url = forceDelete
      ? `/admin/users/${userId}?force=true`
      : `/admin/users/${userId}`;
    const response = await axiosInstance.delete(url);
    return response.data;
  } catch (error: any) {
    console.error(
      "Error deleting user:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

/**
 * קבלת סטטיסטיקות כלליות
 */
export const getSystemOverview = async (schoolId?: string): Promise<any> => {
  try {
    const url = schoolId 
      ? `/admin/statistics/overview?schoolId=${schoolId}`
      : "/admin/statistics/overview";
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error: any) {
    console.error(
      "Error fetching system overview:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

/**
 * קבלת סטטיסטיקות ניקוד
 */
export const getScoreStatistics = async (schoolId?: string): Promise<any> => {
  try {
    const url = schoolId 
      ? `/admin/statistics/scores?schoolId=${schoolId}`
      : "/admin/statistics/scores";
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error: any) {
    console.error(
      "Error fetching score statistics:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

/**
 * קבלת נתוני צמיחת משתמשים לאורך זמן
 */
export const getUserGrowthData = async (schoolId?: string): Promise<any> => {
  try {
    const url = schoolId 
      ? `/admin/statistics/user-growth?schoolId=${schoolId}`
      : "/admin/statistics/user-growth";
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error: any) {
    console.error(
      "Error fetching user growth data:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

/**
 * קבלת היישויות הפעילות ביותר (תלמיד, מורה, בית ספר)
 * לפי כמות הרשומות בטבלת score
 */
export const getMostActiveEntities = async (schoolId?: string): Promise<any> => {
  try {
    const url = schoolId 
      ? `/admin/statistics/most-active?schoolId=${schoolId}`
      : "/admin/statistics/most-active";
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error: any) {
    console.error(
      "Error fetching most active entities:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

/**
 * קבלת נתוני פעילות היררכיים עבור פאנל הניהול
 * מחזיר אובייקט מלא עם בתי ספר, כיתות, תלמידים וספרים
 */
export const getActivityMetrics = async (schoolId?: string, daysAgo?: number): Promise<any> => {
  try {
    const params = new URLSearchParams();
    if (schoolId) params.append('schoolId', schoolId);
    if (daysAgo) params.append('daysAgo', daysAgo.toString());
    
    const url = `/admin/activity-metrics${params.toString() ? `?${params}` : ''}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error: any) {
    console.error(
      "Error fetching activity metrics:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

/**
 * קבלת נתוני כיתות עם בתי ספר ותלמידים
 */
export const getClasses = async (schoolId?: string): Promise<any> => {
  try {
    const url = schoolId 
      ? `/admin/classes?schoolId=${schoolId}`
      : "/admin/classes";
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error: any) {
    console.error(
      "Error fetching classes:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

// קבלת בתי ספר וכיתות
export const getSchoolsAndGrades = async () => {
  try {
    const response = await axiosInstance.get("/admin/users/schools-and-grades");
    return response.data;
  } catch (error) {
    console.error("Error fetching schools and grades:", error);
    throw error;
  }
};

/**
 * הוספת בית ספר חדש
 */
export const createSchool = async (schoolData: { name: string }): Promise<any> => {
  try {
    const response = await axiosInstance.post("/admin/schools", schoolData);
    return response.data;
  } catch (error: any) {
    console.error(
      "Error creating school:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

/**
 * הוספת כיתה חדשה
 */
export const createGrade = async (gradeData: { name: string; school_id: number; teacher_id?: number }): Promise<{ message: string; grade: { id: number; name: string; school_id: number } }> => {
  try {
    const response = await axiosInstance.post("/admin/classes/grades", gradeData);
    return response.data;
  } catch (error: any) {
    console.error(
      "Error creating grade:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

/**
 * מחיקת בית ספר
 */
export const deleteSchool = async (schoolId: number): Promise<any> => {
  try {
    const response = await axiosInstance.delete(`/admin/schools/${schoolId}`);
    return response.data;
  } catch (error: any) {
    console.error(
      "Error deleting school:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

/**
 * עדכון שם כיתה
 */
export const updateGradeName = async (gradeId: number, name: string): Promise<any> => {
  try {
    const response = await axiosInstance.put(`/admin/classes/${gradeId}`, { name });
    return response.data;
  } catch (error: any) {
    console.error(
      "Error updating grade:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

/**
 * מחיקת כיתה
 */
export const deleteGrade = async (gradeId: number): Promise<any> => {
  try {
    const response = await axiosInstance.delete(`/admin/classes/${gradeId}`);
    return response.data;
  } catch (error: any) {
    console.error(
      "Error deleting grade:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

/**
 * ייצוא נתוני בית ספר לקובץ Excel
 */
export const exportSchoolData = async (schoolId: number): Promise<Blob> => {
  try {
    const response = await axiosInstance.get(
      `/admin/export-school/${schoolId}`,
      { responseType: "blob" }
    );
    return response.data;
  } catch (error: any) {
    console.error(
      "Error exporting school data:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

/**
 * Reading Sessions Analytics APIs
 */

/**
 * קבלת KPIs לנתוני קריאה
 */
export const getReadingSessionsKPIs = async (schoolId?: string, daysAgo: number = 30): Promise<any> => {
  try {
    const params = new URLSearchParams();
    if (schoolId) params.append('schoolId', schoolId);
    params.append('daysAgo', daysAgo.toString());
    
    const response = await axiosInstance.get(`/admin/reading-sessions-analytics/kpis?${params}`);
    return response.data;
  } catch (error: any) {
    console.error(
      "Error fetching reading sessions KPIs:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

/**
 * קבלת מגמות לאורך זמן
 */
export const getReadingSessionsTrends = async (schoolId?: string, daysAgo: number = 30): Promise<any> => {
  try {
    const params = new URLSearchParams();
    if (schoolId) params.append('schoolId', schoolId);
    params.append('daysAgo', daysAgo.toString());
    
    const response = await axiosInstance.get(`/admin/reading-sessions-analytics/trends?${params}`);
    return response.data;
  } catch (error: any) {
    console.error(
      "Error fetching reading sessions trends:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

/**
 * קבלת התפלגויות (status, device, browser)
 */
export const getReadingSessionsDistributions = async (schoolId?: string, daysAgo: number = 30): Promise<any> => {
  try {
    const params = new URLSearchParams();
    if (schoolId) params.append('schoolId', schoolId);
    params.append('daysAgo', daysAgo.toString());
    
    const response = await axiosInstance.get(`/admin/reading-sessions-analytics/distributions?${params}`);
    return response.data;
  } catch (error: any) {
    console.error(
      "Error fetching reading sessions distributions:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

/**
 * קבלת רשימת sessions מפורטת
 */
export const getReadingSessionsList = async (
  schoolId?: string,
  daysAgo: number = 30,
  page: number = 1,
  limit: number = 50,
  status?: string,
  deviceType?: string,
  browserName?: string
): Promise<any> => {
  try {
    const params = new URLSearchParams();
    if (schoolId) params.append('schoolId', schoolId);
    params.append('daysAgo', daysAgo.toString());
    params.append('page', page.toString());
    params.append('limit', limit.toString());
    if (status) params.append('status', status);
    if (deviceType) params.append('deviceType', deviceType);
    if (browserName) params.append('browserName', browserName);
    
    const response = await axiosInstance.get(`/admin/reading-sessions-analytics/sessions?${params}`);
    return response.data;
  } catch (error: any) {
    console.error(
      "Error fetching reading sessions list:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};